import React from 'react';

import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { createQuickInsertMatcher } from '@atlaskit/editor-common/quick-insert/create-quick-insert-matcher';
import { RULE_MENU_ITEM, TEXT_FORMATTING_SECTION } from '@atlaskit/editor-common/quick-insert/keys';
import { TEXT_FORMATTING_SECTION_RANK } from '@atlaskit/editor-common/quick-insert/rank';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import type { RulePlugin } from '../../rulePluginType';

import { RuleQuickInsertMenuItem } from './RuleQuickInsertMenuItem';

export const getRuleQuickInsertComponents = ({
	api,
}: {
	api: ExtractInjectionAPI<RulePlugin> | undefined;
}): RegisterMenuItem[] => [
	{
		key: RULE_MENU_ITEM.key,
		type: RULE_MENU_ITEM.type,
		parents: [
			{
				key: TEXT_FORMATTING_SECTION.key,
				type: TEXT_FORMATTING_SECTION.type,
				rank: TEXT_FORMATTING_SECTION_RANK[RULE_MENU_ITEM.key],
			},
		],
		match: createQuickInsertMatcher(({ formatMessage }) => ({
			description: formatMessage(messages.horizontalRuleDescription),
			keywords: ['horizontal', 'rule', 'line', 'hr'],
			shortcut: '---',
			title: formatMessage(messages.horizontalRule),
		})),
		component: () => <RuleQuickInsertMenuItem api={api} />,
	},
];
